/* eslint-disable import/no-unresolved */
import logoWhite from 'assets/resources/logo_white.svg';
import logoBlack from 'assets/resources/logo_black.svg';
import pythonSVG from 'assets/resources/icon/python_icon.svg';
import python2SVG from 'assets/resources/icon/python-2.svg';
import python3SVG from 'assets/resources/icon/python-3.svg';
import djangoSVG from 'assets/resources/icon/django-11.svg';

import GoodFirms1 from 'assets/resources/goodfirms.inline.svg';
import GoodFirms2 from 'assets/resources/goodfirms2.inline.svg';

import icon1SVG from 'assets/resources/pages/about-us/1_icon.svg';
import icon3SVG from 'assets/resources/pages/about-us/3_icon.svg';
import teamextensionSVG from 'assets/resources/icon/teamextension_icon.svg';
import outcomeSVG from 'assets/resources/pages/how-we-do/outcome_icon.svg';
import icon4SVG from 'assets/resources/pages/about-us/4_icon.svg';
import ourroleSVG from 'assets/resources/pages/how-we-do/ourrole_icon.svg';
import vueSVG from 'assets/resources/pages/software-services/logo/vue.svg';
import angularSVG from 'assets/resources/pages/software-services/logo/angular.svg';
import reactSVG from 'assets/resources/pages/software-services/logo/react.svg';
import resultsSVG from 'assets/resources/pages/careers/results_icon.svg';
import LendingblockLogo from '../../static/img/lendingblock-logo.png';
import Steve from '../../static/img/steve-swain.png';

export default {
  logoWhite,
  logoBlack,
  icon1SVG,
  icon3SVG,
  icon4SVG,
  teamextensionSVG,
  outcomeSVG,
  ourroleSVG,
  LendingblockLogo,
  Steve,
  pythonSVG,
  python2SVG,
  python3SVG,
  djangoSVG,
  vueSVG,
  reactSVG,
  angularSVG,
  GoodFirms1,
  GoodFirms2,
  resultsSVG
};
